import Image from "./image";

export default class Carousel {
    id?: number;
    title: string;
    url: string;
    active: boolean|number;
    carousel_image?: CarouselImage;

    constructor(values: CarouselConstructorValues) {
        this.id = values.id;
        this.title = values.title;
        this.url = values.url;
        this.active = values.active;
        this.carousel_image = values.carousel_image;
    }
}

export interface CarouselConstructorValues {
    id?: number;
    title: string;
    url: string;
    active: boolean|number;
    carousel_image?: CarouselImage;
}

export interface CarouselImage {
    id: number;
    micro_site_id: number;
    image_id: number;
    image: Image;
}


export interface SearchCarouselRequestParam {
    search?: string;
    active?: boolean|number;
}
